const capitalizeFirstLetter = (input) => {
    return input?.charAt(0).toUpperCase() + input?.toLowerCase()?.slice(1);
}

export default capitalizeFirstLetter;